import { render } from "./ProgramProgress.vue?vue&type=template&id=32e671da"
import script from "./ProgramProgress.vue?vue&type=script&lang=js"
export * from "./ProgramProgress.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/gonapsacc-11/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__